module.exports = __webpack_public_path__ + "img/epr.dd8adab4.jpg";